module.exports = __webpack_public_path__ + "static/img/7.86bac31f.png";